<form
    *ngIf="formGroup"
    (keydown.enter)="applyFilter()"
    class="jarowa-search-filter"
    fxLayout="column"
    [formGroup]="formGroup"
>
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between start">
        <div class="w-48-p" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="24px">
            <div class="bold-title mb-20">
                <span>{{ "APP_CASES_FILTER.GENERAL" | translate }}</span>
            </div>
            <p-floatlabel variant="on" class="w-100-p form-field-width">
                <label>{{ "APP_CASES.CASE_ID" | translate }}</label>
                <input
                    type="text"
                    pInputText
                    formControlName="ClaimNumber"
                    id="am-1073"
                />
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-100-p form-field-width">
                <p-select
                    class="w-100-p"
                    formControlName="CaseStatus"
                    id="am-1078"
                    [options]="statusList"
                >

                    <ng-template let-option #item>
                        <span>{{ option.Key  | translate }}</span>
                    </ng-template>

                    <ng-template let-value #selectedItem>
                        {{ value.Key | translate }}
                    </ng-template>
                </p-select>
                <label>{{ "APP_CASES.CASE_STATUS" | translate }}</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="w-100-p">
                <p-select
                    class="w-100-p"
                    formControlName="DocumentProcessingStatus"
                    id="am-1077"
                    [options]="documentProcessingStatusList"
                >
                    <ng-template let-option #item>
                        <span>{{ option  | translate }}</span>
                    </ng-template>

                    <ng-template let-value #selectedItem>
                        {{ value | translate }}
                    </ng-template>
                </p-select>
                <label>{{ "APP_CASES.DOC_PROCESS_STATUS" | translate }}</label>
            </p-floatlabel>

            <div class="bold-title">
                <span>{{ "APP_CASES.ASSIGNED_PERSONNELS" | translate }}</span>
            </div>
            <p-floatlabel variant="on" class="w-100-p">
                <p-select
                    appendTo="body"
                    formControlName="InspectorUserId"
                    class="w-100-p"
                    [options]="inspectorUserList"
                    optionLabel="DisplayName"
                    optionValue="CreatedBy"
                    filter="true"
                    filterBy="DisplayName"
                >
                    <ng-template let-option #item>
                        <span>{{ option.DisplayName }}</span>
                    </ng-template>

                    <ng-template let-value #selectedItem>
                        {{ value.DisplayName }}
                    </ng-template>
                </p-select>
                <label>
                    <div fxLayoutAlign="start center">
                        <i class="s-20 mr-4 pi pi-users"></i>
                        <span>{{ "APP_CASES.ASSIGNED_INSPECTOR" | translate }}</span>
                    </div>
                </label>
            </p-floatlabel>
        </div>

        <div class="w-48-p" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="24px">
            <div class="bold-title mb-20">
                <span>{{ "APP_CASES.ORDER_DATE" | translate }}</span>
            </div>
            <div class="calendar-content">
                <p-floatlabel class="form-field-width w-100-p" variant="on">
                    <app-app-pcx-day-picker
                        class="w-100-p"
                        [label]="'APP_CASES.FROM' | translate"
                        [control]="formGroup.get('CreateDateFrom')"
                        [showClearButton]="true"
                        [maxDate]="formGroup.get('CreateDateTo').value"
                        [isTimeShow]="false"
                        [appendTo]="'body'"
                        id="am-1376"

                    >
                    </app-app-pcx-day-picker>
                </p-floatlabel>
            </div>

            <div class="calendar-content">
                <app-app-pcx-day-picker
                    [label]="'APP_CASES.TO' | translate"
                    [control]="formGroup.get('CreateDateTo')"
                    [showClearButton]="true"
                    [isTimeShow]="false"
                    id="am-1377"
                    [minDate]="formGroup.get('CreateDateFrom').value"
                    [appendTo]="'body'"
                >
                </app-app-pcx-day-picker>
            </div>

            <p-floatlabel class="form-field-width w-100-p" variant="on">
                <p-select
                    class="w-100-p"
                    formControlName="Language"
                    id="am-1079"
                    [options]="scConfigLanguages"
                    optionValue="Key"
                    optionLabel="Key"
                >
                    <ng-template let-option #item>
                        <span>{{ option.Key | translate }}</span>
                    </ng-template>

                    <ng-template let-value #selectedItem>
                        {{ value.Key | translate }}
                    </ng-template>
                </p-select>
                <label>{{ "APP_CASES.LANGUAGE" | translate }}</label>
            </p-floatlabel>

            <div class="bold-title">
                <span>{{ "APP_CASES_FILTER.INSURANCE" | translate }}</span>
            </div>

            <p-floatlabel variant="on" class="w-100-p">
                <p-select
                    appendTo="body"
                    formControlName="InsuranceCompany"
                    id="am-1074"
                    class="w-100-p"
                    [options]="insuranceCompanies"
                    filter="true"
                    filterBy="Name"
                >

                    <ng-template let-option #item>
                        <span>{{ option.Name }}</span>
                    </ng-template>

                    <ng-template let-value #selectedItem>
                        {{ value.Name }}
                    </ng-template>
                </p-select>
                <label>{{ "APP_CASES.INSURANCE_PROVIDER" | translate }}</label>
            </p-floatlabel>

            <p-floatlabel variant="on" class="w-100-p mb-12">
                <p-select appendTo="body" formControlName="Department" [options]="formGroup.get('InsuranceCompany').value?.DepartmentInfoList ?? departmentList" class="w-100-p"
                          filter="true" filterBy="DepartmentName">

                    <ng-template let-option #item>
                        <span>{{ option.DepartmentName }}</span>
                    </ng-template>

                    <ng-template let-value #selectedItem>
                        {{ value.DepartmentName }}
                    </ng-template>
                </p-select>
                <label>{{ "APP_CASES.CLIENTELE" | translate }}</label>
            </p-floatlabel>
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px" class="mt-10">
        <button type="button" mat-button (click)="onClose()" appGhostButton>
            <mat-icon class>close</mat-icon>
            <span>{{ "CANCEL" | translate }}</span>
        </button>
        <button type="button" (click)="onClear()" appSecondaryButton mat-flat-button id="am-1080">
            <span>{{ "APP_CASES.RESET_FILTER" | translate }}</span>
        </button>
        <button type="button" (click)="applyFilter()" appPrimaryButton mat-flat-button id="am-1081">
            <span>{{ "APPLY_FILTER" | translate }}</span>
        </button>
    </div>
</form>
